import { Topic } from '../types';

export enum AnimationSlot {
    Majority = 'majority',
    Gender = 'gender',
    QnA = 'qna',
    Age = 'age'
}

export const buildAnimationSequence = (
    topic: Topic | null,
    profile: any
): AnimationSlot[] => {
    const sequence: AnimationSlot[] = [];
    
    const hasMajority = topic?.pvtShowPeopleStats ?? false;
    const hasGender = topic?.pvtShowGenderStats ?? false;
    const hasAge = topic?.pvtShowAgeStats ?? false;
    const hasGenderData = !!(profile?.gender && profile.gender !== 'other');
    
    if (hasMajority) {
        sequence.push(AnimationSlot.Majority);
    }
    
    if (hasGender) {
        sequence.push(AnimationSlot.Gender);
    }
    
    if (hasGender && hasGenderData && hasAge) {
        sequence.push(AnimationSlot.Age);
        sequence.push(AnimationSlot.QnA);
    } else if (hasGender) {
        sequence.push(AnimationSlot.QnA);
        if (hasAge) {
            sequence.push(AnimationSlot.Age);
        }
    } else {
        if (hasAge) {
            sequence.push(AnimationSlot.Age);
        }
        sequence.push(AnimationSlot.QnA);
    }
    
    return sequence;
};

export const getCurrentAnimationSlot = (
    completedSlots: AnimationSlot[],
    sequence: AnimationSlot[]
): AnimationSlot | null => {
    for (const slot of sequence) {
        if (!completedSlots.includes(slot)) {
            return slot;
        }
    }
    return null;
};

export const shouldRenderSlot = (
    slot: AnimationSlot,
    currentSlot: AnimationSlot | null,
    completedSlots: AnimationSlot[],
    topic: Topic | null,
    profile: any
): boolean => {
    if (slot === AnimationSlot.QnA) return false;
    
    if (slot === AnimationSlot.Majority && !topic?.pvtShowPeopleStats) return false;
    if (slot === AnimationSlot.Gender && !topic?.pvtShowGenderStats) return false;
    if (slot === AnimationSlot.Age && !topic?.pvtShowAgeStats) return false;
    
    if (slot === AnimationSlot.Age && topic?.pvtShowGenderStats) {
        const hasGenderData = !!(profile?.gender && profile.gender !== 'other');
        if (!hasGenderData) return false;
    }
    
    return currentSlot === slot || completedSlots.includes(slot);
};

export const shouldShowQnA = (
    currentSlot: AnimationSlot | null
): boolean => {
    return currentSlot === AnimationSlot.QnA;
};

export const getFirstResultSlot = (sequence: AnimationSlot[]): AnimationSlot | null => {
    for (const slot of sequence) {
        if (slot !== AnimationSlot.QnA) {
            return slot;
        }
    }
    return null;
};